
import { Grid, InputAdornment, Paper, Stack, TextField, Typography } from '@mui/material'
import { CalendarPicker, DatePicker, DesktopDatePicker } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react'
import { bottomPosition, customStyles } from '../../../styles';
import { MainContainer } from '../../containers';
import { BodyContainer } from '../../containers/BodyContainer'
import { ScheduleAvailable } from './ScheduleAvailable';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { ModalHeader } from '../../modals';
import { MainButton } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { CustomLoading } from '../../helpers/loading/CustomLoading';
import { formatDate } from '../../../utils/formatDate';
import { loadingSchedules, schedulesAvailables } from '../../../slices/scheduleSlice';
import { getSchedulesAction } from '../../../actions';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { HeaderTabs } from './HeaderTabs';
import { useNavigate } from 'react-router-dom';
import { cancelSchedule } from '../../../slices/orderSlice';
export const PickDate = () => {
  const { scheduleSelected, account } = useSelector(state => state.order)
  const { date, time } = scheduleSelected
  const [token] = useLocalStorage('login-token', null)  
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [handleDisable, setHandleDisable] = useState(true)
  const handleAccept = () => {
    navigate('/dashboard/preview')
  }
  
  const handleCancel = () => {
    dispatch(cancelSchedule())
    navigate('/dashboard/preview')
  }
  useEffect(() => {
    if(time !== null) {
      setHandleDisable(false)
    }
  }, [scheduleSelected])
  useEffect(() => {
    dispatch(getSchedulesAction(account?.id, token.token))
  }, [])
  return (
    <MainContainer sx={{backgroundColor: customStyles.colors.backgroundColor}}>
      <ModalHeader text="Selecciona fecha y horario de entrega" backward={false}/>
      <HeaderTabs />
      <Stack direction="row" spacing={3}>
        <MainButton text="CANCELAR" variant="outlined" size="50%" onClick={handleCancel}/>
        <MainButton text="ACEPTAR" variant="contained" size="50%" onClick={handleAccept} disabled={ handleDisable  }/>
      </Stack>
    </MainContainer>
  )
}
